module.exports = __webpack_public_path__ + "static/fonts/iconfont.e4c0e1c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1610088025011
// module id = zy3+
// module chunks = 78